var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"infoBox",staticClass:"d-box",class:_vm.box_class,staticStyle:{"display":"block"}},[_c('MyContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }